'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      breakpoint = _baseTheme$vstui.breakpoint,
      color = _baseTheme$vstui.color,
      rem = _baseTheme$vstui.rem,
      shadow = _baseTheme$vstui.shadow,
      shape = _baseTheme$vstui.shape,
      typography = _baseTheme$vstui.typography,
      zIndex = _baseTheme$vstui.zIndex,
      primaryMain = color.primary.getMainShade(),
      secondaryMain = color.secondary.getMainShade();
  return (0, _themes.createComponentTheme)(baseTheme, {
    Dialog_zIndex: zIndex.modal,
    Dialog_width_small: '300px',
    Dialog_width_medium: '400px',
    Dialog_width_large: '500px',
    Dialog_backgroundColor: color.surface,
    Dialog_borderRadius: shape.borderRadius,
    Dialog_boxShadow: shadow.high,
    Dialog_fontFamily: typography.fontFamily,
    Dialog_breakpoint_xs: breakpoint.xs,
    DialogBackdrop_backgroundColor: 'rgba(0, 0, 0, 0.5)',
    DialogTitle_backgroundColor: color.transparent,
    DialogTitle_backgroundColor_darkHeaderPrimary: primaryMain,
    DialogTitle_backgroundColor_darkHeaderSecondary: secondaryMain,
    DialogTitle_backgroundColor_fullScreen: color.transparent,
    DialogTitle_borderRadius: shape.borderRadius + ' ' + shape.borderRadius + ' 0 0',
    DialogTitle_borderRadius_fullScreen: 0,
    DialogTitle_boxShadow: '0 4px 3px -3px rgba(0, 0, 0, 0.2)',
    DialogTitle_fontSize: rem(typography.fontSize + 3),
    DialogTitle_fontWeight: typography.fontWeightMedium,
    DialogTitle_color_darkHeaderPrimary: color.onPrimary,
    DialogTitle_color_darkHeaderSecondary: color.onSecondary,
    DialogTitle_color_primary: primaryMain,
    DialogTitle_color_secondary: secondaryMain,
    DialogTitle_color_primary_fullScreen: primaryMain,
    DialogTitle_color_secondary_fullScreen: secondaryMain,
    DialogContent_fontSize: rem(typography.fontSize),
    DialogContent_color: color.onSurface,
    DialogActions_backgroundColor: color.transparent,
    DialogActions_backgroundColor_primary_fullScreen: primaryMain,
    DialogActions_backgroundColor_secondary_fullScreen: secondaryMain,
    DialogActions_borderRadius: '0 0 ' + shape.borderRadius + ' ' + shape.borderRadius,
    DialogActions_borderRadius_fullScreen: 0,
    DialogActions_boxShadow: '0 -4px 3px -3px rgba(0, 0, 0, 0.2)'
  });
};

exports.default = componentTheme;